import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { graphql } from 'gatsby';
import { OmRefinedInPageBanner } from '@om/component-library-react';
import { handleOmButtonClick } from './forms/OmButton';
import { getIsFormOpenAndPrepopulated} from '@om/redux/selectors/publicWeb/callMeBack';

const RefinedInPageBanner = ({
    refinedInPageBannerContent,
    slot
}) => {

    const dispatch = useDispatch();
    let cmbData;

    if(refinedInPageBannerContent){
        cmbData = refinedInPageBannerContent.call_me_back;
    }
   
    const {
        isPrepopulatedCmb
    } = useSelector(
        createStructuredSelector({
            isPrepopulatedCmb: getIsFormOpenAndPrepopulated,

        })
    );

    useEffect(() => {
        if(isPrepopulatedCmb && cmbData)
            handleOmButtonClick(cmbData, dispatch, isPrepopulatedCmb, 'RefinedInPageBanner');
    }, [
        isPrepopulatedCmb, 
        cmbData
    ]);

    if (!refinedInPageBannerContent) {
        return '';
    }

    const {
        has_boundary,
        background,
        button_action_type,
        button_text,
        button_url,
        call_me_back,
        open_tab,
        small_text,
        large_text,
    } = refinedInPageBannerContent;

    return (
        <OmRefinedInPageBanner
            slot={slot}
            hasBoundary={has_boundary}
            background={background && background.url}
            buttonActionType={button_action_type}
            buttonText={button_text}
            buttonUrl={button_url && button_url.href}
            callMeBackObject={call_me_back && JSON.stringify(call_me_back)}
            openTab={open_tab}
        >
            {
                small_text ? <span slot="small-text"
                    dangerouslySetInnerHTML={{__html: small_text}}/> : ''
            }
            {
                large_text ? <span slot="large-text"
                    dangerouslySetInnerHTML={{__html: large_text}}/> : ''
            }
        </OmRefinedInPageBanner>
    );
}


export const pageQuery = graphql`

fragment RefinedInPageBanner on Contentstack_refined_in_page_banner {
    uid
    has_boundary
    background {
        ...File
    }
    button_text
    button_url {
        ...Link
    }
    button_action_type
    call_me_back {
        ...CallMeBack
    }
    small_text
    large_text
    open_tab
}
`;

export default RefinedInPageBanner;
